import axios from 'axios';

const CancelToken = axios.CancelToken;

// codeburst.io/automatically-canceling-previous-requests-in-javascript-606943e2834
export function createCancelTokenHandler(api) {
  const cancelTokenHandler = {};

  for (const key in api) {
    const cancelTokenRequestHandler = { cancelToken: undefined };

    cancelTokenHandler[key] = {
      handleRequestCancellation: () => {
        cancelTokenRequestHandler.cancelToken && cancelTokenRequestHandler.cancelToken.cancel(`${key} cancelled`);
        cancelTokenRequestHandler.cancelToken = CancelToken.source();
        return cancelTokenRequestHandler.cancelToken;
      }
    }
  }

  return cancelTokenHandler;
}


// WEBPACK FOOTER //
// ./src/features/shared/apiRequestCanceler.js